// lot store inner constants

export const GET_MESSAGES = 'messagesGet';
export const GET_MESSAGE = 'messageGet';
export const GET_SETTINGS = 'settingsGet';
export const GET_VERSION = 'versionGet';

export const MUT_MESSAGE = 'setMessage';
export const MUT_MESSAGES = 'setMessages';
export const MUT_CLEAROLDSTATE = 'clearOldState';
export const MUT_MARK_MESSAGE_AS_REPORTED = 'markMessageAsReported';
export const MUT_REMOVE_MESSAGES = 'removeMessages';
export const MUT_REMOVE_ALL_MESSAGES = 'removeAllMessages';
export const MUT_SETTINS = 'setSettings';
export const MUT_VERSION = 'setVersion';
